import { ActionsProps } from '../Types'
import { DrawerProps } from 'components/Drawer/Root'
import { observer } from 'mobx-react-lite'
import { WizardsDrawerV4 } from './WizardsDrawerV4/WizardsDrawerV4'

interface Props extends ActionsProps, DrawerProps {}

export const WizardsDrawer = observer((props: Props) => {
  return <WizardsDrawerV4 {...props} />
})
